export enum OnlineReleaseFiles {
  "LO HBL" = import.meta.env.VITE_LO_HBL ? +import.meta.env.VITE_LO_HBL : 170,
  "LO DEMURRAGE" = import.meta.env.VITE_LO_DEMURRAGE
    ? +import.meta.env.VITE_LO_DEMURRAGE
    : 171,
  "LO PROCURAÇÃO" = import.meta.env.VITE_LO_PROCURACAO
    ? +import.meta.env.VITE_LO_PROCURACAO
    : 174,
  "LO AUTORIZAÇÃO" = import.meta.env.VITE_AUTORIZACAO
    ? +import.meta.env.VITE_AUTORIZACAO
    : 173,
  "LO TERMO ANUAL" = import.meta.env.VITE_TERMO_ANUAL
    ? +import.meta.env.VITE_TERMO_ANUAL
    : 172,
}

export type FileDescription =
  | "LO HBL"
  | "LO DEMURRAGE"
  | "LO PROCURAÇÃO"
  | "LO AUTORIZAÇÃO"
  | "LO TERMO ANUAL";

export type DocumentsContent = {
  status: string;
  category: "onlineRelease";
  createdAt: string;
  description: FileDescription;
  guid: null;
  id: number;
  idGroupFile: number;
  name: string;
  originalName: string;
  type: string;
  updatedAt: string;
  url: string;
};

export type ReleaseDocuments = {
  hbl?: DocumentsContent;
  demurrage?: DocumentsContent;
  annualTerm?: DocumentsContent;
  authorization?: DocumentsContent;
  procuration?: DocumentsContent;
};

export interface ReleaseDocumentsTableData extends Partial<DocumentsContent> {
  documentName: string;
}
